import React from "react";
import { useCheckoutThemeContext } from "repoV2/features/CheckoutPages/modules/CheckoutThemeContextProvider";
import { classNames } from "repoV2/utils/common/render/classNames";
import { IVariant } from "repoV2/features/Listing/Listing.interfaces";
import {
    colorWithAlpha,
    getComplimentaryHexColorFromRgbCssString,
} from "repoV2/features/Common/modules/Colors/utils/rgbColors.utils";
import styles from "./VariantsSelectorSection.module.scss";

const VariantSelectorSection = (props: {
    order: string[];
    renderData: Record<string, string[]>;
    isVariantSelected: boolean;
    selectedVariants: Record<string, string>;
    selectedMerchandiseVariant: IVariant;
    outOfStockVariants: Record<string, boolean>;
    handleSelectedVariantChange: ({
        key,
        value,
    }: {
        key: string;
        value: string;
    }) => void;
}) => {
    const {
        order,
        renderData,
        isVariantSelected,
        selectedVariants,
        selectedMerchandiseVariant,
        outOfStockVariants,
        handleSelectedVariantChange,
    } = props;
    const { colors } = useCheckoutThemeContext();
    const { color1 } = colors || {};
    const selectedColor = getComplimentaryHexColorFromRgbCssString({
        rgbCssString: color1,
    });

    return (
        <div className={styles.mainContainer}>
            {order.map(variantName => (
                <div className={styles.singleVariantContainer}>
                    <div className={styles.variantTitleStyles}>
                        {variantName}
                    </div>
                    <div className={styles.variantsValueContainer}>
                        {renderData[variantName].map(variantValue => {
                            const possibleSelectedVariants = {
                                ...selectedVariants,
                                [variantName]: variantValue,
                            };
                            // Variant is of the format -
                            // Color=red,Size=Merdium...
                            // so we first make the key of the possibly selected variant
                            const possibleVariantKey = order
                                .map(
                                    vn =>
                                        `${vn}=${possibleSelectedVariants[vn]}`
                                )
                                .join(",");
                            return (
                                <div
                                    className={classNames(
                                        styles.variantValueStyles,
                                        outOfStockVariants[
                                            possibleVariantKey
                                        ] && styles.outOfStockStyles
                                    )}
                                    onClick={() => {
                                        if (
                                            outOfStockVariants[
                                                possibleVariantKey
                                            ]
                                        ) {
                                            return;
                                        }
                                        handleSelectedVariantChange({
                                            key: variantName,
                                            value: variantValue,
                                        });
                                    }}
                                    style={{
                                        backgroundColor:
                                            selectedVariants[variantName] ===
                                            variantValue
                                                ? color1
                                                : colorWithAlpha(color1, 0.1),
                                        color:
                                            selectedVariants[variantName] ===
                                            variantValue
                                                ? selectedColor
                                                : color1,
                                    }}
                                    key={variantValue}
                                >
                                    {variantValue}
                                </div>
                            );
                        })}
                    </div>
                </div>
            ))}
            {isVariantSelected &&
                !selectedMerchandiseVariant.allow_overflow &&
                selectedMerchandiseVariant.total_inventory -
                    selectedMerchandiseVariant.purchased_inventory <=
                    2 && (
                    <div className={styles.stockTextStyles}>
                        Only{" "}
                        {selectedMerchandiseVariant.total_inventory -
                            selectedMerchandiseVariant.purchased_inventory}{" "}
                        left in stock!
                    </div>
                )}
        </div>
    );
};

export default VariantSelectorSection;
